import React from 'react';
import { SmallSwitch } from '@/components/ui/small-switch';
import { useRecoilState } from 'recoil';
import { showBlockGainLoss, showBlockNetTaxImpact } from 'venn-state';

interface TaxImpactSettingsProps {
  blockId: string;
  readonly?: boolean;
}

export const TaxImpactSettings = ({ blockId, readonly }: TaxImpactSettingsProps) => {
  const [showGainLoss, setShowGainLoss] = useRecoilState(showBlockGainLoss(blockId));
  const [showNetTaxImpact, setShowNetTaxImpact] = useRecoilState(showBlockNetTaxImpact(blockId));
  return (
    <div className="flex flex-col gap-[8px] pb-[8px]">
      <div className="flex justify-between">
        <span className="font-bold text-[12px]">Show Gain/Loss</span>
        <SmallSwitch
          checked={showGainLoss}
          onCheckedChange={setShowGainLoss}
          disabled={readonly}
          data-testid="qa-filtering-merge-toggle"
        />
      </div>
      <div className="flex justify-between">
        <span className="font-bold  text-[12px]">Show Net Estimated Tax Impact</span>
        <SmallSwitch
          checked={showNetTaxImpact}
          onCheckedChange={setShowNetTaxImpact}
          disabled={readonly}
          data-testid="qa-filtering-merge-toggle"
        />
      </div>
    </div>
  );
};
